/**
 * Convierte un rectángulo del lienzo al sistema PDF que ya usa el firmante.
 * Es la misma álgebra de handleSigningMode: borde izquierdo, Y invertida
 * desde el borde inferior del rectángulo, y tamaño en puntos según el scale.
 * No aplica desplazamientos de estampado.
 */
export function lienzoFirmaAPdf({
  x,
  y,
  anchoLienzo,
  altoLienzo,
  pdfWidth,
  pdfHeight,
  scale,
}) {
  const canvasWidth = pdfWidth * scale
  const canvasHeight = pdfHeight * scale
  const xRatio = x / canvasWidth
  const yBottomRatio = (y + altoLienzo) / canvasHeight
  return {
    coordenadas_x: Math.round(xRatio * pdfWidth),
    coordenadas_y: Math.round((1 - yBottomRatio) * pdfHeight),
    ancho: Math.max(1, Math.round(anchoLienzo / scale)),
    alto: Math.max(1, Math.round(altoLienzo / scale)),
  }
}

/** Inversa de lienzoFirmaAPdf. Devuelve la fracción del lienzo, independiente del zoom. */
export function pdfALienzoFirma({
  coordenadas_x,
  coordenadas_y,
  ancho,
  alto,
  pdfWidth,
  pdfHeight,
}) {
  return {
    xRatio: coordenadas_x / pdfWidth,
    yRatio: 1 - (coordenadas_y + alto) / pdfHeight,
    wRatio: ancho / pdfWidth,
    hRatio: alto / pdfHeight,
  }
}
